import { useState } from 'react';
import axios from "@fetch/axios";
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useTranslation } from '@hooks/useTranslation';
import Spinner from '@components/Spinner';

const CambiarPassword = () => {

	const [clave, setClave] = useState(null);
	const [confirmar, setConfirmar] = useState(null);
	const MySwal = withReactContent(Swal)
	const { token } = useParams();
	const navigate = useNavigate();
	const { translate } = useTranslation();
	const [loading, setLoading] = useState(true)

	const TogglePassword = (event) => {
		event = event.target;
		event.classList.toggle('icon-EyeClosed');
		event.classList.toggle('icon-EyeOpen');
		event = event.previousElementSibling;
		if (event.toggleAttribute('type')) {
			event.type = 'password';
		}
	};

	const cambiar = async () => {

		if (!clave || !confirmar) {
			MySwal.fire({
				text: translate('error.field'),
				icon: 'error',
				title: 'Oops...'
			})
			return;
		}

		if (clave != confirmar) {
			MySwal.fire({
				text: translate('error.pass'),
				icon: 'error',
				title: 'Oops...'
			})
			return;
		}
		try {
			setLoading(false)
			const res = await axios.put(
				"/users/password-reset",
				{
					token: token,
					password: clave,
					password_confirmation: confirmar
				}
			);
			setLoading(true)
			if (res.data.errors) {
				MySwal.fire({
					text: res.data.message,
					icon: 'error',
					title: 'Oops...'
				})
			} else {
				localStorage.removeItem('token_email');
				localStorage.removeItem('token_recuperar_clave');
				navigate('/cambiar-contrasena-exito')
			}
		} catch (error) {
			setLoading(false)
			MySwal.fire({
				text: translate('error.passe'),
				icon: 'error',
				title: 'Oops...'
			})
		}
	}
	
	return (
		<>
			{!loading && <Spinner />}

			{/* if not <> -> use className='DataBox' */}
			<div className='TextLeft'>
				<p>Ingresa tu nueva contraseña</p>
			</div>
			{/**
			  *
			  * ! InvalidInput className in label-> error input style
			  *
			  **/}
			<label className='FormData'>
				<em className='RequiredData'>Nueva contarseña</em>
				<div className='FormInput'>
					<input placeholder='Nueva contarseña' onChange={(e) => { setClave(e.target.value) }}
						type='password' />
					<i className='InputIcon icon-EyeClosed' onClick={TogglePassword}></i>
				</div>
				<em className='InfoData'>Contraseña incorrecta</em>
			</label>
			<label className='FormData'>
				<em className='RequiredData'>Repetir nueva contarseña</em>
				<div className='FormInput'>
					<input placeholder='Repetir nueva contarseña' onChange={(e) => { setConfirmar(e.target.value) }}
						type='password' />
					<i className='InputIcon icon-EyeClosed' onClick={TogglePassword}></i>
				</div>
				<em className='InfoData'>Contraseña incorrecta</em>
			</label>
			<div className='ButtonLightMedium' onClick={cambiar}>
				CAMBIAR CONTRASEÑA
				<i className='icon-ArrowRight'></i>
			</div>
		</>
	);
};

export default CambiarPassword;